export default {
    en: {
        'label.dashboard': 'Dashboard',
        'label.bi-analytics': 'BI & Analytics'
    },
    bn: {
        'label.dashboard': 'ড্যাশবোর্ড',
        'label.bi-analytics': 'বিআই এবং বিশ্লেষণ'
    },

    te: {
        'label.dashboard': 'డాష్బోర్డ్',
        'label.bi-analytics': 'బిఐ & విశ్లేషణ'
    },

    hi: {
        'label.dashboard': 'डैशबोर्ड',
        'label.bi-analytics': 'बीआई और विश्लेषण'
    }

}